import { makeHook } from "../../utils/makeSingleArgHook";
import { getPortfolioAssignment, url, } from "../request/getPortfolioPlanAssignment";
export function assignmentKeyMaker(queryParams) {
    return [url(queryParams)];
}
const useGetPortfolioPlanAssignments = makeHook(getPortfolioAssignment, assignmentKeyMaker);
export default useGetPortfolioPlanAssignments;
//# sourceMappingURL=usePortfolioPlanAssignment.js.map